import {
  Box,
  Button,
  SimpleGrid,
  Text,
  useMediaQuery,
  useToast,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import SuccessBuy from "../modals/SuccessBuy";

export default function ProductCard({ name, price, image, sellerId, itemId }) {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const toast = useToast();
  const [mobile] = useMediaQuery("(max-width: 600px)");

  const [modalSuccess, setModalSuccess] = useState(false);

  var IDRConvert = Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
  });

  const handleBuy = () => {
    if (localStorage.getItem("access_token") === null) {
      toast({
        title: "Login Required",
        description: "Anda harus login agar bisa membeli barang",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
    axios
      .post(
        baseURL + "/carts",
        {
          seller_id: sellerId,
          item_id: itemId,
          qty: 1,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setModalSuccess(true);
        }
      })
      .catch((e) => {
        console.log(e);
        if (e.response.status === 400) {
        }
      });
  };

  const handleClose = () => {
    setModalSuccess(false);
    window.location.replace("/keranjang");
  };

  return (
    <Box
      borderRadius="10px"
      display="flex"
      alignItems="center"
      flexDir="column"
      boxShadow="base"
    >
      <img
        src={image}
        alt={name}
        style={{
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
          height: "200px",
          width: "100%",
        }}
      />
      <SimpleGrid p="2" w="full">
        <Text fontSize="14px" fontWeight="400">
          {name}
        </Text>
        <Text pt="1" pb="3" fontSize="18px" fontWeight="600">
          {IDRConvert.format(price)}
        </Text>
        <SimpleGrid columns={mobile ? 1 : 2} spacing={1}>
          <Button colorScheme="blue" w="full" size="sm" onClick={handleBuy}>
            Beli Langsung
          </Button>
          <Link
            reloadDocument
            to={"/perusahaan/" + sellerId + "/detail/" + itemId}
          >
            <Button variant="outline" colorScheme="blue" w="full" size="sm">
              Lihat Detail
            </Button>
          </Link>
        </SimpleGrid>
      </SimpleGrid>
      <SuccessBuy isOpen={modalSuccess} onClose={handleClose} product={name} />
    </Box>
  );
}
